module.exports = require("./nmg-CM.js");